import {View } from 'react-native'
import React from 'react'
import { ButtonList, ButtonList2 } from '../../../../../element/Button'
import { CheckBox } from './CheckBox'
import { useState } from 'react'
import {AbilityModal, ArcaneModal} from './AbilityModal'



const Description = props => {
    const [flip, setFlip]= useState(true)
  return (
    <View style={{width:'100%', flexDirection:'row', marginLeft:15}} key={props.keys}>
      {flip? <ButtonList wsize={props.size} text={props.ability} onPress={()=>{setFlip(!flip)}}/>:<AbilityModal modalv={!flip} title={props.title} type={props.type} description={props.description} prerequisite={props.prerequisite} onPress={()=>{setFlip(!flip)}} key={props.keys}/>}
     {props.checkBox? <></>:<CheckBox isChecked={props.Check} onPress1={props.onPress2} onChangeValue={props.onChangeValue1}/>}
    </View>
  )
}

const Description1 = props => {
  const [flip, setFlip]= useState(true)
return (
  <View style={{width:'100%', alignItems:'center', alignSelf:'center'}} key={props.keys}>
    {flip? <ButtonList wsize={props.size} text={props.ability} onPress={()=>{setFlip(!flip)}}/>:<AbilityModal modalv={!flip} title={props.title} type={props.type} description={props.description} prerequisite={props.prerequisite} onPress={()=>{setFlip(!flip)}} key={props.keys}/>}
  </View>
)
}

const Description2 = props => {
  const [flip, setFlip]= useState(true)
return (
  <View style={{width:'100%', alignItems:'center', alignSelf:'center'}} key={props.keys}>
    {flip? <ButtonList2 wsize={props.size} text={props.Name} onPress={()=>{setFlip(!flip)}}/>:<ArcaneModal modalv={!flip} title={props.Name} erinni={props.erinni} description={props.description} onPress={()=>{setFlip(!flip)}} key={props.keys}/>}
  </View>
)
}


export {Description, Description1, Description2}
